import { render, staticRenderFns } from "./LaporanOmzet.vue?vue&type=template&id=21c25aff&scoped=true&"
import script from "./LaporanOmzet.vue?vue&type=script&lang=js&"
export * from "./LaporanOmzet.vue?vue&type=script&lang=js&"
import style0 from "./LaporanOmzet.vue?vue&type=style&index=0&id=21c25aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c25aff",
  null
  
)

export default component.exports